import { css as v, LitElement as g, html as r, nothing as d } from "lit";
import { property as n, customElement as m } from "lit/decorators.js";
import { classMap as h } from "lit/directives/class-map.js";
import { b as u } from "./styles-scZ6dVz-.js";
import { b as f, a as w } from "./events-CkEPl0SM.js";
var b = Object.defineProperty, x = Object.getOwnPropertyDescriptor, s = (a, e, c, i) => {
  for (var t = i > 1 ? void 0 : i ? x(e, c) : e, l = a.length - 1, p; l >= 0; l--)
    (p = a[l]) && (t = (i ? p(e, c, t) : p(t)) || t);
  return i && t && b(e, c, t), t;
};
let o = class extends g {
  constructor() {
    super(...arguments), this.variant = "info", this.closable = !1, this.compact = !1, this.noIcon = !1;
  }
  handleClose() {
    f(this, w.CLOSE);
  }
  getDefaultIcon() {
    return {
      info: r`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>
        </svg>
      `,
      success: r`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>
        </svg>
      `,
      warning: r`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><path d="M12 9v4"/><path d="M12 17h.01"/>
        </svg>
      `,
      error: r`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/>
        </svg>
      `
    }[this.variant];
  }
  render() {
    const a = {
      message: !0,
      [this.variant]: !0,
      compact: this.compact
    }, e = r`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
      </svg>
    `;
    return r`
      <div
        part="message"
        class=${h(a)}
        role="alert"
      >
        ${this.noIcon ? d : r`
              <span part="icon" class="icon">
                <slot name="icon">${this.getDefaultIcon()}</slot>
              </span>
            `}

        <div part="content" class="content">
          ${this.messageTitle ? r`<p part="title" class="title">${this.messageTitle}</p>` : d}
          <p part="description" class="description">
            <slot></slot>
          </p>
          <div part="action" class="action">
            <slot name="action"></slot>
          </div>
        </div>

        ${this.closable ? r`
              <button
                part="close"
                class="close"
                type="button"
                aria-label="Close"
                @click=${this.handleClose}
              >
                ${e}
              </button>
            ` : d}
      </div>
    `;
  }
};
o.styles = [
  u,
  v`
      :host {
        display: block;
      }

      .message {
        display: flex;
        gap: var(--r5-space-3);
        padding: var(--r5-space-4);
        border-radius: var(--r5-radius-lg);
        border: 1px solid transparent;
      }

      /* Variants */
      .info {
        background-color: var(--r5-color-info-50);
        border-color: var(--r5-color-info-200);
        color: var(--r5-color-info-700);
      }

      .success {
        background-color: var(--r5-color-success-50);
        border-color: var(--r5-color-success-200);
        color: var(--r5-color-success-700);
      }

      .warning {
        background-color: var(--r5-color-warning-50);
        border-color: var(--r5-color-warning-200);
        color: var(--r5-color-warning-700);
      }

      .error {
        background-color: var(--r5-color-danger-50);
        border-color: var(--r5-color-danger-200);
        color: var(--r5-color-danger-700);
      }

      /* Icon */
      .icon {
        flex-shrink: 0;
        display: flex;
        align-items: flex-start;
        padding-top: 0.125rem;
      }

      .icon svg {
        width: 1.25rem;
        height: 1.25rem;
      }

      /* Content */
      .content {
        flex: 1;
        min-width: 0;
      }

      .title {
        font-weight: var(--r5-font-semibold);
        font-size: var(--r5-text-sm);
        margin: 0 0 var(--r5-space-1) 0;
      }

      .title:only-child {
        margin: 0;
      }

      .description {
        font-size: var(--r5-text-sm);
        opacity: 0.9;
        margin: 0;
      }

      /* Close button */
      .close {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.5rem;
        height: 1.5rem;
        margin: -0.25rem -0.25rem -0.25rem 0;
        padding: 0;
        border: none;
        background: transparent;
        color: currentColor;
        opacity: 0.5;
        cursor: pointer;
        border-radius: var(--r5-radius-md);
        transition: opacity var(--r5-duration-fast) var(--r5-ease-default);
      }

      .close:hover {
        opacity: 1;
      }

      .close svg {
        width: 1rem;
        height: 1rem;
      }

      /* Action slot */
      .action {
        margin-top: var(--r5-space-3);
        display: flex;
        gap: var(--r5-space-2);
      }

      .action:empty {
        display: none;
      }

      /* Compact variant */
      .compact {
        padding: var(--r5-space-3);
        gap: var(--r5-space-2);
      }

      .compact .title {
        font-size: var(--r5-text-xs);
      }

      .compact .description {
        font-size: var(--r5-text-xs);
      }

      .compact .icon svg {
        width: 1rem;
        height: 1rem;
      }
    `
];
s([
  n({ type: String, reflect: !0 })
], o.prototype, "variant", 2);
s([
  n({ type: String, attribute: "title" })
], o.prototype, "messageTitle", 2);
s([
  n({ type: Boolean, reflect: !0 })
], o.prototype, "closable", 2);
s([
  n({ type: Boolean, reflect: !0 })
], o.prototype, "compact", 2);
s([
  n({ type: Boolean, attribute: "no-icon" })
], o.prototype, "noIcon", 2);
o = s([
  m("ark-message")
], o);
export {
  o as A
};
//# sourceMappingURL=ark-message-CANDrFh4.js.map
